import React, { useState, useRef } from "react";
import styled, { css } from "styled-components";
import { FipayLogo, Footer, Footer1 } from "./PaymentInfo.styled";
import SuccessModal from "./SuccessModal";

const Confirmation: React.FC = () => {
  const [pins, setPins] = useState<string[]>(["", "", "", ""]);
  const refs = [
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
  ];
  const [selectedMethod, setSelectedMethod] = useState<string>("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handlePinChange = (index: number, value: string) => {
    const newPins = [...pins];
    newPins[index] = value.replace(/\D/g, "").slice(0, 1);
    setPins(newPins);

    if (value && index < 3) {
      refs[index + 1].current?.focus();
    } else if (!value && index > 0) {
      refs[index - 1].current?.focus();
    }
  };

  const handleKeyDown = (
    index: number,
    e: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (e.key === "Backspace" && index > 0 && !pins[index]) {
      refs[index - 1].current?.focus();
    }
  };

  const handlePayButtonClick = () => {
    if (pins.every((pin) => pin !== "")) {
      setShowSuccessModal(true);
    }
  };

  return (
    <Container>
      <PageTitle1 $small>
        Please enter your 4-digit pin to complete the transaction
      </PageTitle1>
      <PinInputContainer>
        {pins.map((pin, index) => (
          <PinInput
            key={index}
            ref={refs[index]}
            type="password"
            maxLength={1}
            value={pin}
            onChange={(e) => handlePinChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
          />
        ))}
      </PinInputContainer>
      <PayButton
        disabled={pins.some((pin) => pin === "")}
        onClick={handlePayButtonClick}
      >
        Pay
      </PayButton>
      {showSuccessModal && <SuccessModal show={showSuccessModal} />}
      <Footer1>
        Secured by <FipayLogo />
      </Footer1>
    </Container>
  );
};

export default Confirmation;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;
  height: 100%;
  margin-top: 1rem;
  padding: 1rem 0;
`;

export const PageTitle1 = styled.span<{ $small?: boolean }>`
  font-size: ${({ $small }) => ($small ? 0.75 : 0.875)}rem;
  font-weight: 400;
  color: #5e5e5e;
  margin-top: 2rem;
  margin-bottom: 20px;
  padding-left: 3.3rem;
`;

export const PageTitle2 = styled.span<{ $small?: boolean }>`
  font-size: ${({ $small }) => ($small ? 0.75 : 0.875)}rem;
  font-weight: 400;
  color: #5e5e5e;
  margin-top: 1.5rem;
  margin-bottom: 10px;
  padding-left: 0.1rem;
`;

const PinInputContainer = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 2rem;
  height: 55px;
  margin-bottom: 9rem;
  justify-content: center;
`;

const PinInput = styled.input`
  padding: 5px;
  padding-right: 8px;
  width: 38px;
  text-align: center;
  font-size: 16px;
  border-radius: 0.75rem;
  border: 1px #cfcfcf solid;
  align-items: center;

  &:focus {
    outline: none;
  }

  font-family: "Courier New", Courier, monospace;
`;

const PayButton = styled.button<{ disabled: boolean }>`
  padding: 10px 20px;
  font-size: 18px;
  background-color: #00a603;
  color: white;
  border: none;
  cursor: pointer;
  transition: opacity 0.3s;
  border-radius: 0.75rem;
  margin-bottom: 0.1rem;

  ${(props) =>
    props.disabled &&
    css`
      opacity: 30%;
      cursor: not-allowed;
    `}
`;
